var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "warning",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd15b",
    d: "m21.442,17.263l-7.319-12.785c-.434-.757-1.246-1.228-2.118-1.228s-1.684.47-2.118,1.227l-7.328,12.786c-.202.352-.309.752-.309,1.158,0,1.285,1.045,2.33,2.329,2.33h14.842c1.284,0,2.329-1.045,2.329-2.33,0-.404-.106-.804-.308-1.157Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494249",
    d: "m21.442,17.263l-7.319-12.785c-.434-.757-1.246-1.228-2.118-1.228s-1.684.47-2.118,1.227l-7.328,12.786c-.202.352-.309.752-.309,1.158,0,1.285,1.045,2.33,2.329,2.33h14.842c1.284,0,2.329-1.045,2.329-2.33,0-.404-.106-.804-.308-1.157Zm-2.021,1.987H4.579c-.457,0-.829-.372-.829-.83,0-.145.038-.287.109-.412l7.328-12.785c.168-.292.48-.473.817-.473s.649.182.816.474l7.318,12.784c.072.126.11.269.11.413,0,.458-.372.83-.829.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#494249",
    d: "m12,13.95c.414,0,.75-.336.75-.75v-3.2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.2c0,.414.336.75.75.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.2,
    r: 0.8,
    fill: "#494249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1532d944344d2019ebec4e16a40f664b.svg";
export { ForwardRef as ReactComponent };